// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import model_1 from '/root/workspace/__flow_work/__flow_builds/739bc73d-3054-4196-a84b-7b0da5dda974/workspace/repo_0/src/.umi-production/plugin-initialState/@@initialState';

export const models = {
model_1: { namespace: '@@initialState', model: model_1 },
} as const
